<template>
  <MainNavbar class="bg-transparent fixed-top border-bottom" mwClass="" className="m-auto" />
  <div class="testimonial-page pt-227 pb-100">
    <Testimonial1Content />
  </div>
  <MainFooter />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import MainNavbar from "../components/Layouts/MainNavbar.vue";
import MainFooter from "../components/Layouts/MainFooter.vue";
import Testimonial1Content from "../components/OurTeam/Testimonial1Content.vue";

export default defineComponent({
  name: "Testimonial1Page",
  components: {
    MainNavbar,
    MainFooter,
    Testimonial1Content,
  },
});
</script>

<style scoped>
.testimonial-page {
  padding: 100px 20px 20px 20px;
}
</style>
